import { Checkbox } from '@1trading/react/components/ui/checkbox';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@1trading/react/components/ui/form';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { PageHeading, PageHeadingTitle } from '@/components/ui/page-heading';
import type { InstitutionFuturesReportingEmirOrDefaults } from '@/features/institution/futures/reporting/schema';

const InstitutionFuturesReportingFieldsetEmirLegend = () => {
  const { t } = useTranslation();

  return (
    <PageHeading asChild>
      <legend>
        <PageHeadingTitle>{t('institutionDetails.reporting.emirDetails.title')}</PageHeadingTitle>
      </legend>
    </PageHeading>
  );
};
InstitutionFuturesReportingFieldsetEmirLegend.displayName = 'InstitutionFuturesReportingFieldsetEmirLegend';

const InstitutionFuturesReportingFieldsetEmir = () => {
  const form = useFormContext<InstitutionFuturesReportingEmirOrDefaults>();
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <FormField
        control={form.control}
        name="emirUtiAcknowledgment"
        render={({ field }) => (
          <FormItem>
            <div className="flex flex-row items-center gap-4">
              <FormControl>
                <Checkbox checked={field.value} onCheckedChange={field.onChange} />
              </FormControl>
              <FormLabel>{t('institutionDetails.reporting.emirDetails.emirUtiAcknowledgment')}</FormLabel>
            </div>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="emirPostTradeRiskConfirmation"
        render={({ field }) => (
          <FormItem>
            <div className="flex flex-row items-center gap-4">
              <FormControl>
                <Checkbox checked={field.value} onCheckedChange={field.onChange} />
              </FormControl>
              <FormLabel>{t('institutionDetails.reporting.emirDetails.emirPostTradeRiskConfirmation')}</FormLabel>
            </div>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
InstitutionFuturesReportingFieldsetEmir.displayName = 'InstitutionFuturesReportingFieldsetEmir';

export { InstitutionFuturesReportingFieldsetEmir, InstitutionFuturesReportingFieldsetEmirLegend };
